import styles from "./profile-name-contactInfo.module.scss"
import { ReactComponent as User } from "assets/images/v2/user.svg";
import { ReactComponent as FilePen } from "assets/images/v2/file-pen.svg";
import { ReactComponent as TriangleExclamation } from "assets/images/v2/triangleExclamation.svg";
import {
  PROFILE_NAME_LABEL,
  PROFILE_CONTACT_INFO_LABEL,
  PROFILE_EMAIL_LABEL,
  PROFILE_PHONE_LABEL,
  PROFILE_ERROR_LOAD_NAME,
  PROFILE_ERROR_LOAD_EMAIL,
  PROFILE_ERROR_LOAD_PHONE,
  PROFILE_LABEL_PHONE,
} from "utilities/Constant";
import { BorrowerDetails } from "pages/dashboard/home/dashboardService";

interface ProfileNameContactInfoProps {
readonly borrower?: BorrowerDetails;
}

export default function ProfileNameContactInfo({ borrower }: ProfileNameContactInfoProps) {
  return (
    <>
      {/* Profile Name */}
      <div className={styles.profileWrapper}>
        <div className={styles.profileName}>
          <User className="icon" />
          <span>{PROFILE_NAME_LABEL}</span>
        </div>
        <div className={borrower ? styles.profileNameValue : styles.profileErrorValue}>
          {borrower?.firstName ? (
            `${borrower.firstName} ${borrower.lastName}`
          ) : (
            <>
              <TriangleExclamation className={styles.profileInfoErrorIcon} />
              {PROFILE_ERROR_LOAD_NAME}
            </>
          )}
        </div>
      </div>

      {/* Contact Info */}
      <div className={styles.profileContactWrapper}>
        <div className={styles.profileContactTitle}>
          <FilePen className="icon" />
          <span>{PROFILE_CONTACT_INFO_LABEL}</span>
        </div>
        <div className={styles.profileContactEmail}>
          <div>
            <p className={styles.profileContactEmailLabel}>{PROFILE_EMAIL_LABEL}</p>
            <p className={borrower?.emailAddress ? styles.profileContactEmailValue : styles.profileErrorValue}>
              {borrower?.emailAddress ? (
                borrower.emailAddress
              ) : (
                <>
                  <TriangleExclamation className={styles.profileInfoErrorIcon} />
                  {PROFILE_ERROR_LOAD_EMAIL}
                </>
              )}
            </p>
          </div>
          <div className={styles.profileContactPhone}>
            <p className={styles.profileContactPhoneLabel}>{PROFILE_PHONE_LABEL}</p>
            <p className={borrower?.phoneNumber ? styles.profileContactPhoneValue : styles.profileErrorValue}>
              {borrower?.phoneNumber ? (
                <> {PROFILE_LABEL_PHONE}: {borrower.phoneNumber}</>
              ) : (
                <>
                  <TriangleExclamation className={styles.profileInfoErrorIcon} />
                  {PROFILE_ERROR_LOAD_PHONE}
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
